import React, { useEffect, useState } from 'react';
import { Button, buttonVariants } from './ui/button';

function CookiesReferenceButton({ data, id }) {
  const [isBrowser, setIsBrowser] = useState(false);

  useEffect(() => {
    setIsBrowser(true);
  }, []);

  const handleClick = () => {
    if (isBrowser) {
      window.showConsentPreferencesPopup();
    }
  };

  if (!isBrowser) {
    return null;
  }

  return (
    <section id={id} className="prose -mt-[20px] pb-10 lg:-mt-[90px]">
      <div className="relative mx-auto max-w-339 px-8 3xl:px-0">
        <Button
          className={`${buttonVariants({ variant: 'primary' })} home-banner-button flex w-fit justify-center md:w-fit`}
          onClick={handleClick}>
          {data.title}
        </Button>
      </div>
    </section>
  );
}

export default CookiesReferenceButton;
